// src/content/explore/articles.js

const articlesContext = require.context('./', true, /metadata\.json$/);

const articles = articlesContext.keys().map((key) => {
  const meta = articlesContext(key);
  const id = key.match(/\.\/(.*?)\//)[1];
  return {
    ...meta,
    id,
  };
});

export default articles;